import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CanActivate } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

import * as UserActions from '../../state/user.actions';
import { getToken } from '../../state/user.selectors';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private auth: AuthService,
    private router: Router,
    private store$: Store
  ) {}

  canActivate(): Observable<boolean> {
    return this.store$.select(getToken).pipe(
      map((token) => {
        if (
          token === undefined ||
          token === '' ||
          this.auth.isTokenExpired(token)
        ) {
          this.store$.dispatch(UserActions.loginRedirect());
          return false;
        }
        return true;
      }),
      take(1)
    );
  }
}
